// extracted by mini-css-extract-plugin
export var container = "_5c-0";
export var fallback = "_5c-5";
export var fallbackIcon = "_5c-6";
export var hidden = "_5c-2";
export var image = "_5c-3";
export var loaded = "_5c-4";
export var placeholder = "_5c-1";